import styled from 'styled-components'
import {
  flexDirection,
  FlexDirectionProps,
  padding,
  PaddingProps,
} from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

const shouldForwardProp = (prop: string) => !['flexDirection'].includes(prop)

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<PaddingProps & FlexDirectionProps>`
  display: flex;
  align-items: center;
  width: 100%;
  gap: ${themeGet('space.4')}px;
  padding-top: ${themeGet('space.4')}px;
  border-top: 1px solid ${themeGet('colors.text.inverse')};

  > a {
    text-decoration: none;
    border-bottom: 1px solid ${themeGet('colors.text.inverse')};
  }

  > p {
    border-bottom: 1px solid transparent;
  }

  ${padding}
  ${flexDirection}
`

export const Divider = styled.div`
  width: 1px;
  height: 12px;
  background-color: ${themeGet('colors.text.inverse')};
`
